import { ArticleModuleAudio } from '#components/Article/Modules/ArticleModuleAudio';
import { ArticleModuleEmbed } from '#components/Article/Modules/ArticleModuleEmbed';
import { ArticleModuleGallery } from '#components/Article/Modules/ArticleModuleGallery';
import { ArticleModuleImage } from '#components/Article/Modules/ArticleModuleImage';
import { ArticleModuleLivestream } from '#components/Article/Modules/ArticleModuleLivestream';
import { ArticleModuleText } from '#components/Article/Modules/ArticleModuleText';
import { ArticleModuleVideo } from '#components/Article/Modules/ArticleModuleVideo';
import { logger } from '#utils/logging/logger';

import type { ArticleModuleFragment } from './__generated__/ArticleModule.generated';

type Props = {
	articleModule: ArticleModuleFragment;
	articlePublicationDate: string | null | undefined;
	articleRowId: string;
};

export function ArticleModule({ articleModule, articlePublicationDate, articleRowId }: Props) {
	switch (articleModule.type) {
		case 'AUDIO':
			return <ArticleModuleAudio audioModule={articleModule} publicationDate={articlePublicationDate} />;

		case 'EMBED':
			return <ArticleModuleEmbed embedModule={articleModule} articleId={articleRowId} />;

		case 'GALLERY':
			return <ArticleModuleGallery galleryModule={articleModule} />;

		case 'IMAGE':
			return <ArticleModuleImage imageModule={articleModule} />;

		case 'LIVESTREAM':
			return <ArticleModuleLivestream livestreamModule={articleModule} publicationDate={articlePublicationDate} />;

		case 'TEXT':
			return <ArticleModuleText textModule={articleModule} />;

		case 'VIDEO':
			return <ArticleModuleVideo videoModule={articleModule} publicationDate={articlePublicationDate} />;

		case 'VIDEO360':
			logger.error(`Tried to play 'Video360'. Module: rowId: '%s.'`, articleModule.rowId);

			return null;

		default:
			logger.error(
				`Unknown module type in article '%s'. Module: rowId: '%s', type: '%s'.`,
				articleRowId,
				articleModule.rowId,
				articleModule.type
			);

			return null;
	}
}
